import { Record } from "immutable";
import { Reducer } from "redux";
import { ThunkAction } from "redux-thunk";
import { reducer as rsfFormReducer, initialState as rsfFormInitState } from "common/reducers/rsfForm.reducer";
import { RsfFormActions } from "common/reducers/rsfForm.actions";
import {
  reducer as screenSharesReducer,
  initialState as ScreenSharesInitialState,
} from "common/reducers/screenShare.reducer";
import { ScreenShareActions } from "common/reducers/screenShare.actions";
import { reducer as jobsReducer, initialState as JobsInitialState } from "common/reducers/job.reducer";
import { JobActions } from "common/reducers/job.actions";
import { CommonActions } from "common/reducers/common.actions";
import { reducer as commonReducer, initialState as commonInitialState } from "common/reducers/common.reducer";
import { RouterActions } from "common/reducers/router.actions";
import { reducer as routerReducer, initialState as routerInitialState } from "common/reducers/router.reducer";
import { OrgActions } from "common/reducers/org.actions";
import { reducer as orgsReducer, initialState as OrgsInitialState } from "common/reducers/org.reducer";
import { JobResultingActions } from "common/reducers/jobResulting.actions";
import {
  reducer as jobResultingReducer,
  initialState as jobResultingInitialState,
} from "common/reducers/jobResulting.reducer";
import { reducer as userReducer, initialState as userInitialState } from "common/reducers/user.reducer";
import { UserActions } from "common/reducers/user.actions";
import { reducer as authReducer, initialState as AuthInitialState } from "common/reducers/auth.reducer";
import { AuthActions } from "common/reducers/auth.actions";
import { BillingActions } from "common/reducers/billing.actions";
import { reducer as billingReducer, initialState as BillingInitialState } from "common/reducers/billing.reducer";
import { PresentationActions } from "common/reducers/presentation.actions";
import {
  reducer as presentationReducer,
  initialState as PresentationInitialState,
} from "common/reducers/presentation.reducer";
import { DocumentActions } from "common/reducers/document.actions";
import { reducer as documentReducer, initialState as DocumentInitialState } from "common/reducers/document.reducer";
import {
  reducer as estimateTemplateReducer,
  initialState as EstimateTemplateInitialState,
} from "common/reducers/estimateTemplate.reducer";
import { SlideActions } from "common/reducers/slide.actions";
import { reducer as slideReducer, initialState as SlideInitialState } from "common/reducers/slide.reducer";
import { FolderActions } from "common/reducers/folder.actions";
import { reducer as folderReducer, initialState as FolderInitialState } from "common/reducers/folder.reducer";
import { ImageActions } from "common/reducers/image.actions";
import { reducer as imageReducer, initialState as ImageInitialState } from "common/reducers/image.reducer";
import { LevelActions } from "common/reducers/level.actions";
import { reducer as levelReducer, initialState as LevelInitialState } from "common/reducers/level.reducer";
import { reducer as jobTypeReducer, initialState as JobTypeInitialState } from "common/reducers/jobType.reducer";
import { LocationActions } from "common/reducers/location.actions";
import { reducer as locationReducer, initialState as LocationInitialState } from "common/reducers/location.reducer";
import { ActivatedPriceListActions } from "common/reducers/activatedPriceList.actions";
import {
  initialState as activatedPriceListInitialState,
  reducer as activatedPriceListReducer,
} from "common/reducers/activatedPriceList.reducer";
import { PriceListActions } from "common/reducers/priceList.actions";
import { PriceListProcessActions } from "common/reducers/priceListProcess.actions";
import { ProductActions } from "common/reducers/product.actions";
import { initialState as productInitialState, reducer as productReducer } from "common/reducers/product.reducer";
import { initialState as priceListInitialState, reducer as priceListReducer } from "common/reducers/priceList.reducer";
import {
  initialState as productProcessInitialState,
  reducer as productProcessReducer,
} from "common/reducers/productProcess.reducer";
import { ProductProcessActions } from "common/reducers/productProcess.actions";
import {
  initialState as priceListProcessInitialState,
  reducer as priceListProcessReducer,
} from "common/reducers/priceListProcess.reducer";
import { TaskActions } from "common/reducers/task.actions";
import { initialState as taskInitialState, reducer as taskReducer } from "common/reducers/task.reducer";
import {
  reducer as idsManagementReducer,
  initialState as IdsManagementInitialState,
} from "common/reducers/idsManagement.reducer";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import { reducer as accessReducer, initialState as AccessInitialState } from "common/reducers/access.reducer";
import { AccessActions } from "common/reducers/access.actions";
import { ToolActions } from "common/reducers/tool.actions";
import { reducer as toolReducer, initialState as ToolInitialState } from "common/reducers/tool.reducer";
import { reducer as webhooksReducer, initialState as WebhooksInitialState } from "common/reducers/webhook.reducer";
import { WebhookActions } from "common/reducers/webhook.actions";
import { FinanceOptionActions } from "common/reducers/financeOption.actions";
import {
  reducer as financeOptionsReducer,
  initialState as FinanceOptionsInitialState,
} from "common/reducers/financeOption.reducer";
import { DiscountActions } from "common/reducers/discount.actions";
import { reducer as discountReducer, initialState as DiscountInitialState } from "common/reducers/discount.reducer";
import { EstimateComparisonActions } from "common/reducers/estimateComparison.actions";
import {
  reducer as estimateComparisonReducer,
  initialState as EstimateComparisonInitialState,
} from "common/reducers/estimateComparison.reducer";
import { PaymentTermActions } from "common/reducers/paymentTerm.actions";
import {
  reducer as paymentTermReducer,
  initialState as PaymentTermInitialState,
} from "common/reducers/paymentTerm.reducer";
import { reducer as tokensReducer, initialState as TokensInitialState } from "common/reducers/token.reducer";
import { initialState as CrmUserInitialState, reducer as crmUserReducer } from "common/reducers/crmUser.reducer";
import { CrmUserActions } from "common/reducers/crmUser.actions";
import { TokenActions } from "common/reducers/token.actions";
import { JobTypeActions } from "common/reducers/jobType.actions";
import { reducer as skuReducer, initialState as SkuInitialState } from "common/reducers/sku.reducer";
import { SkuActions } from "common/reducers/sku.actions";
import { reducer as patternsReducer, initialState as PatternsInitialState } from "common/reducers/pattern.reducer";
import { PatternActions } from "common/reducers/pattern.actions";
import { reducer as estimatesReducer, initialState as EstimatesInitialState } from "common/reducers/estimate.reducer";
import { EstimateActions } from "common/reducers/estimate.actions";
import {
  estimateGroupsReducer,
  initialState as EstimateGroupsInitialState,
} from "common/reducers/estimateGroup.reducer";
import { EstimateGroupActions } from "common/reducers/estimateGroup.actions";
import {
  estimateLineItemsReducer,
  initialState as EstimateLineItemsInitialState,
} from "common/reducers/estimateLineItem.reducer";
import { EstimateLineItemActions } from "common/reducers/estimateLineItem.actions";
import {
  openingEstimationReducer,
  initialState as OpeningEstimationsInitialState,
} from "common/reducers/openingEstimation.reducer";
import { OpeningEstimationActions } from "common/reducers/openingEstimation.actions";

import {
  estimateLineItemOptionsReducer,
  initialState as EstimateLineItemOptionsInitialState,
} from "common/reducers/estimateLineItemOption.reducer";
import { EstimateLineItemOptionActions } from "common/reducers/estimateLineItemOption.actions";
import { EventResultActions } from "common/reducers/eventResult.actions";
import {
  reducer as eventResultReducer,
  initialState as eventResultInitialState,
} from "common/reducers/eventResult.reducer";
import { reducer as estimateEditorReducer } from "common/reducers/estimateEditor.reducer";
import { EstimateEditorActions } from "common/reducers/estimateEditor.actions";
import { ProductOptionGroupActions } from "common/reducers/productOptionGroup.action";
import {
  reducer as productOptionGroupReducer,
  initialState as ProductOptionGroupInitialState,
} from "common/reducers/productOptionGroup.reducer";
import { PaymentActions } from "common/reducers/payment.actions";
import { reducer as paymentReducer, initialState as PaymentInitialState } from "common/reducers/payment.reducer";
import { AnalyticsActions } from "common/reducers/analytics.actions";
import { reducer as analyticsReducer, initialState as AnalyticsInitialState } from "common/reducers/analytics.reducer";
import { ValidationActions } from "common/reducers/validation.actions";
import {
  initialState as validationInitialState,
  reducer as validationReducer,
} from "common/reducers/validation.reducer";
import { PaySimpleActions } from "common/reducers/paySimple.actions";
import { reducer as paySimpleReducer, initialState as PaySimpleInitialState } from "common/reducers/paySimple.reducer";
import { EventActions } from "common/reducers/event.actions";
import { reducer as eventReducer, initialState as EventInitialState } from "common/reducers/event.reducer";
import { ProductOptionActions } from "common/reducers/productOption.action";
import {
  reducer as productOptionReducer,
  initialState as ProductOptionInitialState,
} from "common/reducers/productOption.reducer";
import {
  reducer as productToOptionGroupLinkReducer,
  initialState as ProductToOptionGroupLinkInitialState,
} from "common/reducers/productToOptionGroupLink.reducer";
import { ProductToOptionGroupLinkActions } from "common/reducers/productToOptionGroupLink.actions";
import { NoteActions } from "common/reducers/note.actions";
import { initialState as noteInitialState, reducer as noteReducer } from "common/reducers/note.reducer";
import {
  initialState as paymentRequestInitialState,
  reducer as paymentRequestReducer,
} from "common/reducers/paymentRequest.reducer";
import { PaymentRequestActions } from "common/reducers/paymentRequest.actions";
import { MeasurementActions } from "common/reducers/measurement.actions";
import {
  initialState as measurementInitialState,
  reducer as measurementReducer,
} from "common/reducers/measurement.reducer";
import { SignedDocumentActions } from "common/reducers/signedDocument.actions";
import {
  initialState as signedDocumentInitialState,
  reducer as signedDocumentReducer,
} from "common/reducers/signedDocument.reducer";
import { WindowActions } from "common/reducers/window.actions";
import { windowReducer, initialState as windowInitialState } from "common/reducers/window.reducer";
import { DoorActions } from "common/reducers/door.actions";
import { doorReducer, initialState as doorInitialState } from "common/reducers/door.reducer";
import { initialState as roofFaceInitialState, reducer as roofFaceReducer } from "common/reducers/roofFace.reducer";
import { RoofFaceActions } from "common/reducers/roofFace.actions";
import {
  initialState as wallFacadeInitialState,
  reducer as wallFacadeReducer,
} from "common/reducers/wallFacade.reducer";
import { WallFacadeActions } from "common/reducers/wallFacade.actions";
import { EventResultReasonActions } from "common/reducers/eventResultReason.actions";
import {
  reducer as eventResultReasonReducer,
  initialState as eventResultReasonInitialState,
} from "common/reducers/eventResultReason.reducer";
import { CalendarActions } from "common/reducers/calendar.actions";
import { calendarReducer, initialState as calendarInitialState } from "common/reducers/calendar.reducer";
import {
  reducer as measurementLinkReducer,
  initialState as measurementLinkInitialState,
} from "common/reducers/measurementLink.reducer";
import { MeasurementLinkActions } from "common/reducers/measurementLink.actions";
import { RoomActions } from "common/reducers/room.actions";
import { roomReducer, initialState as roomInitialState } from "common/reducers/room.reducer";
import { reducer as fenceReducer, initialState as fenceInitialState } from "common/reducers/fence.reducer";
import { FenceActions } from "common/reducers/fence.actions";
import { reducer as fencingReducer, initialState as fencingInitialState } from "common/reducers/fencing.reducer";
import { FencingActions } from "common/reducers/fencing.actions";
import { reducer as segmentReducer, initialState as segmentInitialState } from "common/reducers/segment.reducer";
import { SegmentActions } from "common/reducers/segment.actions";
import { reducer as reportReducer, initialState as reportInitialState } from "common/reducers/report.reducer";
import { ReportActions } from "common/reducers/report.actions";
import { reducer as statsReducer, initialState as statsInitialState } from "common/reducers/stats.reducer";
import { StatsActions } from "common/reducers/stats.actions";
import { EmailActions } from "common/reducers/email.actions";
import { reducer as emailReducer, initialState as emailInitialState } from "common/reducers/email.reducer";
import { HoverActions } from "common/reducers/hover.actions";
import { reducer as hoverReducer, initialState as hoverInitialState } from "common/reducers/hover.reducer";
import { JobStateLogActions } from "common/reducers/jobStateLog.actions";
import {
  reducer as jobStateLogReducer,
  initialState as jobStateLogInitialState,
} from "common/reducers/jobStateLog.reducer";
import { EagleviewProductActions } from "common/reducers/eagleviewProduct.actions";
import {
  reducer as eagleviewProductReducer,
  initialState as eagleviewProductInitialState,
} from "common/reducers/eagleViewProduct.reducer";
import { VisualizationActions } from "common/reducers/visualization.action";
import {
  reducer as visualizationReducer,
  initialState as VisualizationInitialState,
} from "common/reducers/visualization.reducer";
import { IntegrationErrorActions } from "common/reducers/integrationError.actions";
import {
  reducer as integrationErrorReducer,
  initialState as IntegrationErrorInitialState,
} from "common/reducers/integrationError.reducer";
import { EstimateFinanceOptionActions } from "common/reducers/estimateFinanceOption.actions";
import {
  reducer as estimateFinanceOptionReducer,
  initialState as EstimateFinanceOptionInitialState,
} from "common/reducers/estimateFinanceOption.reducer";
import { OneLookActions } from "common/reducers/oneLook.actions";
import { reducer as oneLookReducer, initialState as oneLookInitialState } from "common/reducers/oneLook.reducer";
import { CustomFormActions } from "common/reducers/customForm.actions";
import { customFormsReducer, customFormsInitialState } from "common/reducers/customForm.reducer";
import { DabellaCustomFormActions } from "common/reducers/dabellaCustomForm.actions";
import {
  reducer as dabellaCustomFormReducer,
  initialState as dabellaCustomFormInitialState,
} from "common/reducers/dabellaCustomForm.reducer";
import { PricePresentationActions } from "common/reducers/pricePresentation.actions";
import { pricePresentationReducer, pricePresentationInitialState } from "common/reducers/pricePresentation.reducer";
import { ProviaActions } from "common/reducers/provia.actions";
import { reducer as proviaReducer, initialState as proviaInitialState } from "common/reducers/provia.reducer";
import { FeneTechActions } from "common/reducers/fenetech.actions";
import { reducer as feneTechReducer, initialState as feneTechInitialState } from "common/reducers/fenetech.reducer";
import { OpeningsWizardActions } from "common/reducers/openingsWizard.actions";
import {
  reducer as openingsWizardReducer,
  initialState as openingsWizardInitialState,
} from "common/reducers/openingsWizard.reducer";
import { ElevationActions } from "common/reducers/elevation.actions";
import { elevationReducer, initialState as elevationInitialState } from "common/reducers/elevation.reducer";
import { AppMessageActions } from "common/reducers/appMessage.actions";
import {
  reducer as appMessageReducer,
  initialState as appMessageInitialState,
} from "common/reducers/appMessage.reducer";
import { UiActions } from "common/reducers/ui.actions";
import { reducer as uiReducer, initialState as uiInitialState } from "common/reducers/ui.reducer";

export const InitRootState = Record({
  rsfForms: rsfFormInitState,
  common: commonInitialState,
  router: routerInitialState,
  orgs: OrgsInitialState,
  screenShares: ScreenSharesInitialState,
  jobs: JobsInitialState,
  users: userInitialState,
  auth: AuthInitialState,
  priceLists: priceListInitialState,
  priceListProcesses: priceListProcessInitialState,
  products: productInitialState,
  productProcesses: productProcessInitialState,
  activatedPriceLists: activatedPriceListInitialState,
  billing: BillingInitialState,
  presentations: PresentationInitialState,
  documents: DocumentInitialState,
  skus: SkuInitialState,
  slides: SlideInitialState,
  folders: FolderInitialState,
  images: ImageInitialState,
  levels: LevelInitialState,
  locations: LocationInitialState,
  tasks: taskInitialState,
  idsManagement: IdsManagementInitialState,
  accesses: AccessInitialState,
  webhooks: WebhooksInitialState,
  tools: ToolInitialState,
  financeOptions: FinanceOptionsInitialState,
  discounts: DiscountInitialState,
  estimateComparisons: EstimateComparisonInitialState,
  paymentTerms: PaymentTermInitialState,
  payments: PaymentInitialState,
  analytics: AnalyticsInitialState,
  tokens: TokensInitialState,
  jobTypes: JobTypeInitialState,
  crmUsers: CrmUserInitialState,
  patterns: PatternsInitialState,
  estimates: EstimatesInitialState,
  estimateTemplates: EstimateTemplateInitialState,
  estimateGroups: EstimateGroupsInitialState,
  estimateLineItems: EstimateLineItemsInitialState,
  openingEstimations: OpeningEstimationsInitialState,
  estimateLineItemOptions: EstimateLineItemOptionsInitialState,
  estimateFinanceOptions: EstimateFinanceOptionInitialState,
  doors: doorInitialState,
  windows: windowInitialState,
  eventResults: eventResultInitialState,
  productOptionGroups: ProductOptionGroupInitialState,
  productOptions: ProductOptionInitialState,
  productToOptionGroupLinks: ProductToOptionGroupLinkInitialState,
  validations: validationInitialState,
  paySimple: PaySimpleInitialState,
  events: EventInitialState,
  notes: noteInitialState,
  paymentRequests: paymentRequestInitialState,
  measurements: measurementInitialState,
  signedDocuments: signedDocumentInitialState,
  roofFaces: roofFaceInitialState,
  wallFacades: wallFacadeInitialState,
  eventResultReasons: eventResultReasonInitialState,
  calendars: calendarInitialState,
  measurementLinks: measurementLinkInitialState,
  rooms: roomInitialState,
  measurementsFences: fenceInitialState,
  measurementsFencings: fencingInitialState,
  measurementsSegments: segmentInitialState,
  reports: reportInitialState,
  stats: statsInitialState,
  emails: emailInitialState,
  hoverJobs: hoverInitialState,
  jobStateLogs: jobStateLogInitialState,
  eagleviewProducts: eagleviewProductInitialState,
  visualizations: VisualizationInitialState,
  jobResulting: jobResultingInitialState,
  integrationErrors: IntegrationErrorInitialState,
  oneLook: oneLookInitialState,
  customForms: customFormsInitialState,
  dabellaCustomForms: dabellaCustomFormInitialState,
  pricePresentation: pricePresentationInitialState,
  provia: proviaInitialState,
  fenetech: feneTechInitialState,
  openingsWizard: openingsWizardInitialState,
  elevations: elevationInitialState,
  appMessages: appMessageInitialState,
  ui: uiInitialState,
})();

export type RootState = typeof InitRootState;

export const createRootReducer = () => {
  return ((state: RootState, action: RootActions) => {
    if (!state) {
      state = InitRootState;
    }

    state = rsfFormReducer(state, action);
    state = routerReducer(state, action);
    state = commonReducer(state, action);
    state = orgsReducer(state, action);
    state = screenSharesReducer(state, action);
    state = jobsReducer(state, action);
    state = userReducer(state, action);
    state = authReducer(state, action);
    state = priceListReducer(state, action);
    state = priceListProcessReducer(state, action);
    state = productReducer(state, action);
    state = productProcessReducer(state, action);
    state = activatedPriceListReducer(state, action);
    state = billingReducer(state, action);
    state = presentationReducer(state, action);
    state = documentReducer(state, action);
    state = slideReducer(state, action);
    state = skuReducer(state, action);
    state = folderReducer(state, action);
    state = imageReducer(state, action);
    state = levelReducer(state, action);
    state = locationReducer(state, action);
    state = taskReducer(state, action);
    state = idsManagementReducer(state, action);
    state = accessReducer(state, action);
    state = webhooksReducer(state, action);
    state = toolReducer(state, action);
    state = financeOptionsReducer(state, action);
    state = discountReducer(state, action);
    state = estimateComparisonReducer(state, action);
    state = paymentTermReducer(state, action);
    state = paymentReducer(state, action);
    state = analyticsReducer(state, action);
    state = tokensReducer(state, action);
    state = jobTypeReducer(state, action);
    state = crmUserReducer(state, action);
    state = patternsReducer(state, action);
    state = estimatesReducer(state, action);
    state = estimateTemplateReducer(state, action);
    state = estimateGroupsReducer(state, action);
    state = estimateLineItemsReducer(state, action);
    state = openingEstimationReducer(state, action);
    state = estimateLineItemOptionsReducer(state, action);
    state = estimateFinanceOptionReducer(state, action);
    state = windowReducer(state, action);
    state = doorReducer(state, action);
    state = eventResultReducer(state, action);
    state = productOptionGroupReducer(state, action);
    state = productOptionReducer(state, action);
    state = productToOptionGroupLinkReducer(state, action);
    state = estimateEditorReducer(state, action);
    state = validationReducer(state, action);
    state = paySimpleReducer(state, action);
    state = eventReducer(state, action);
    state = noteReducer(state, action);
    state = paymentRequestReducer(state, action);
    state = measurementReducer(state, action);
    state = signedDocumentReducer(state, action);
    state = roofFaceReducer(state, action);
    state = wallFacadeReducer(state, action);
    state = eventResultReasonReducer(state, action);
    state = calendarReducer(state, action);
    state = measurementLinkReducer(state, action);
    state = roomReducer(state, action);
    state = fenceReducer(state, action);
    state = fencingReducer(state, action);
    state = segmentReducer(state, action);
    state = reportReducer(state, action);
    state = statsReducer(state, action);
    state = emailReducer(state, action);
    state = hoverReducer(state, action);
    state = jobStateLogReducer(state, action);
    state = eagleviewProductReducer(state, action);
    state = visualizationReducer(state, action);
    state = jobResultingReducer(state, action);
    state = integrationErrorReducer(state, action);
    state = oneLookReducer(state, action);
    state = customFormsReducer(state, action);
    state = dabellaCustomFormReducer(state, action);
    state = pricePresentationReducer(state, action);
    state = proviaReducer(state, action);
    state = feneTechReducer(state, action);
    state = openingsWizardReducer(state, action);
    state = elevationReducer(state, action);
    state = appMessageReducer(state, action);
    state = uiReducer(state, action);

    return state;
  }) as Reducer<RootState, RootActions>;
};

export type RootActions =
  | RsfFormActions
  | CommonActions
  | RouterActions
  | OrgActions
  | AuthActions
  | UserActions
  | ScreenShareActions
  | JobActions
  | PriceListActions
  | PriceListProcessActions
  | ProductActions
  | ProductProcessActions
  | ActivatedPriceListActions
  | BillingActions
  | PresentationActions
  | DocumentActions
  | SlideActions
  | SkuActions
  | FolderActions
  | ImageActions
  | LevelActions
  | LocationActions
  | TaskActions
  | IdsManagementActions
  | AccessActions
  | WebhookActions
  | ToolActions
  | FinanceOptionActions
  | DiscountActions
  | EstimateComparisonActions
  | PaymentTermActions
  | PaymentActions
  | AnalyticsActions
  | TokenActions
  | JobTypeActions
  | CrmUserActions
  | PatternActions
  | EstimateActions
  | EstimateGroupActions
  | EstimateLineItemActions
  | OpeningEstimationActions
  | EstimateLineItemOptionActions
  | EstimateFinanceOptionActions
  | WindowActions
  | DoorActions
  | EventResultActions
  | ProductOptionGroupActions
  | ProductOptionActions
  | ProductToOptionGroupLinkActions
  | EstimateEditorActions
  | ValidationActions
  | PaySimpleActions
  | EventActions
  | NoteActions
  | MeasurementActions
  | SignedDocumentActions
  | PaymentRequestActions
  | SignedDocumentActions
  | MeasurementActions
  | CalendarActions
  | RoofFaceActions
  | WallFacadeActions
  | EventResultReasonActions
  | MeasurementLinkActions
  | RoomActions
  | FenceActions
  | FencingActions
  | SegmentActions
  | ReportActions
  | StatsActions
  | EmailActions
  | HoverActions
  | JobStateLogActions
  | EagleviewProductActions
  | VisualizationActions
  | JobResultingActions
  | IntegrationErrorActions
  | OneLookActions
  | CustomFormActions
  | DabellaCustomFormActions
  | PricePresentationActions
  | ProviaActions
  | FeneTechActions
  | OpeningsWizardActions
  | ElevationActions
  | AppMessageActions
  | UiActions;

export type ThunkResult<T> = ThunkAction<T, RootState, undefined, RootActions>;
